<template>
  <div class="reservation-detail" v-loading="loading">
    <!-- 预约信息 -->
    <div class="info-card">
      <div class="flex-between">
        <h3 class="card-title">预约信息</h3>
        <el-button @click="refresh">刷新</el-button>
      </div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="预约编号">
          {{ detail.goodsOrderNo }}
          <el-button type="text" class="ml-5" @click="$utils.copyText(detail.goodsOrderNo)">复制</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag v-for="item in $const.TRAVELRESERVATIONSTATUS.filter(item => item.value === detail.status)"
            :key="item.value" :type="item.type">{{ item.label }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="机构名称">
          {{ detail.organizationName }}
        </el-descriptions-item>
        <el-descriptions-item label="产品名称">
          {{ detail.goodsName }}
        </el-descriptions-item>
        <el-descriptions-item label="实付金额">
          <span class="util-money">¥{{ detail.price }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="来源">
          {{ $const.TRAVELORDERSOURCE.find(item => item.value == detail.channel)?.label || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="联系人">
          {{ detail.contactPerson }}
        </el-descriptions-item>
        <el-descriptions-item label="联系电话">
          {{ detail.contactPhone }}
          <el-button type="text" class="ml-5" @click="$utils.copyText(detail.contactPhone)">复制</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="行程人数">
          {{ detail.passengerNum }}人
        </el-descriptions-item>
        <el-descriptions-item label="预约日期">
          {{ detail.orderDate | filterTime('YYYY-MM-DD') }}
        </el-descriptions-item>
        <el-descriptions-item label="下单时间">
          {{ detail.created | filterTime }}
        </el-descriptions-item>
        <el-descriptions-item label="确认/取消时间">
          {{ detail.operateTime | filterTime }}
        </el-descriptions-item>
        <el-descriptions-item label="服务内容">
          {{ detail.lineType | filterConst('LYLINETYPE') }} / {{ detail.poolType | filterConst('LYPOOLTYPE') }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ detail.remark || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="取消原因">
          {{ detail.cancelReason || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <el-tabs v-model="activeTab" style="margin-top: 20px;" @tab-click="tabClick">
        <el-tab-pane label="订单信息" name="trip">
          <el-table :data="detail.orders" border height="calc(100vh - 450px)">
            <el-table-column prop="travelLineName" label="线路名称" min-width="150" show-overflow-tooltip />
            <el-table-column prop="orderNo" label="订单编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.orderNo }}
                <el-button type="text" class="ml-5" @click="$utils.copyText(scope.row.orderNo)">复制</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="60">
              <template slot-scope="scope">
                <el-tag v-for="item in $const.TRAVELALLORDERSTATUS.filter(item => item.value == scope.row.status)"
                  :key="item.value" :type="item.type">{{ item.label }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="orderTime" label="用车时间" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.orderTime">{{ scope.row.orderTime | filterTime }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="startPointName" label="出发地" min-width="150" show-overflow-tooltip />
            <el-table-column prop="endPointName" label="目的地" min-width="150" show-overflow-tooltip />
            <el-table-column prop="trafficType" label="航班号/班次号" min-width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.trafficNo && scope.row.trafficType">{{ scope.row.trafficNo }}({{ scope.row.trafficType }})</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status == 5" type="text" size="mini"
                  @click="confirmTrip(scope.row)">确认</el-button>
                <el-button v-if="scope.row.status == 8 || scope.row.status == 10" type="text" size="mini"
                  @click="modifyTrip(scope.row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="协议签订" name="agreement">
          <el-table :data="signingList" border height="calc(100vh - 450px)" :loading="tableLoading">
            <el-table-column prop="agreementNo" label="记录ID" />
            <el-table-column prop="title" label="协议名称" />
            <el-table-column prop="agreementContent" label="协议全文">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="viewAgreement(scope.row)">点击查看</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="created" label="签订时间">
              <template slot-scope="scope">
                {{ scope.row.created | filterTime }}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="操作历史" name="history">
          <el-table :data="operationHistory" border  height="calc(100vh - 450px)" :loading="tableLoading">
            <el-table-column prop="remark" label="记录内容" />
            <el-table-column prop="operator" label="操作人" />
            <el-table-column prop="created" label="记录时间" width="180">
              <template slot-scope="scope">
                {{ scope.row.created | filterTime }}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="协议全文" width="400px" :before-close="closeAgreement">
      <div v-html="agreementContent" class="agreement-content"></div>
      <div slot="footer" class="agreement-footer">
        <el-button type="primary" @click="closeAgreement">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ReservationDetail',
  data() {
    return {
      id: this.$route.query.id,
      activeTab: 'trip',
      detail: {
        orders: [],
        
      },
      operationHistory: [],
      signingList: [],
      loading: false,
      tableLoading: false,
      dialogVisible: false,
      agreementContent: ''
    }
  },
  created() {
    this.getDetail()
    this.getOperationHistory()
  },
  methods: {
    viewAgreement(row) {
      this.dialogVisible = true
      this.agreementContent = row.content
    },
    closeAgreement() {
      this.dialogVisible = false
      this.agreementContent = ''
    },
    goBack() {
      this.$router.go(-1)
    },
    async getDetail() {
      this.loading = true;
      let url = "/api/v1/manage/travelOrder/goods/order/detail";
      let params = {
        id: this.id
      }
      let { code, data } = await this.$axios.get(url, params)
      if (code === 1) {
        this.detail = { 
          ...data,
          organizationName: await this.getOrgName(data.organizationId)
         }
        this.organizationName = await this.getOrgName(data.organizationId)
      }
      this.loading = false;
    },

    confirmTrip(row) {
      this.$router.push({
        path: '/travelReservationSure',
        query: {
          type: 'confirm',
          travelLineId: row.travelLineId,
          orderId: row.id,
          remark: this.detail.remark,
          orderDate: this.detail.orderDate,
          orderTime: row.orderTime
        }
      })
    },
    modifyTrip(row) {
      this.$router.push({
        path: '/travelReservationSure',
        query: {
          type: 'update',
          travelLineId: row.travelLineId,
          orderId: row.id,
          remark: this.detail.remark,
          orderDate: this.detail.orderDate,
          orderTime: row.orderTime
        }
      })
    },
    tabClick(tab) {
      if (tab.name === 'history') {
        this.getOperationHistory()
      }else if (tab.name === 'agreement') {
        this.getAgreementList()
      }
    },
    // 获取操作记录
    async getOperationHistory() {
      this.tableLoading = true
      let url = "/api/v1/manage/travelOrder/operation/logs";
      let params = {
        goodsOrderId: this.id
      }
      let { code, data } = await this.$axios.get(url, params)
      if (code == 1) {
        this.operationHistory = data
      }
      this.tableLoading = false
    },
    // 获取协议签订记录
    async getAgreementList() {
      this.tableLoading = true
      let url = "/api/v1/manage/travelOrder/goods/order/agreement";
      let params = {
        id: this.id
      }
      let { code, data } = await this.$axios.get(url, params)
      if (code == 1) {
        this.signingList = data
      }
      this.tableLoading = false
    },
    refresh() {
      this.getDetail()
      this.getOperationHistory()
    }
  }
}
</script>

<style lang="less" scoped>
.reservation-detail {
  // 信息卡片
  .info-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0;
    padding-left: 10px;
    border-left: 3px solid #2B77FF;
  }

  // 价格样式
  .util-money {
    font-weight: 600;
    color: #F56C6C;
  }

  .ml-5 {
    margin-left: 5px;
  }

  // 描述列表样式
  :deep(.el-descriptions) {
    border-radius: 8px;
    overflow: hidden;
  }

  :deep(.el-descriptions-item__label) {
    width: 90px;
    font-weight: 500;
    color: #606266;
    background: #f5f7fa;
  }

  :deep(.el-descriptions-item__content) {
    min-width: 150px;
    color: #303133;
  }

  // Tab样式
  :deep(.el-tabs) {
    .el-tabs__item {
      font-size: 14px;
      
      &.is-active {
        font-weight: 500;
        color: #2B77FF;
      }
    }
    
    .el-tabs__active-bar {
      background-color: #2B77FF;
    }
  }

  // 表格样式
  :deep(.el-table) {
    border-radius: 8px;
    
    th {
      background: #f5f7fa !important;
      font-weight: 500;
    }
    
    .el-button--text {
      color: #2B77FF;
      
      &:hover {
        color: #1a5fd9;
      }
    }
  }

  // 协议内容
  .agreement-content {
    width: 100%;
    height: 60vh;
    overflow-y: auto;
    padding: 16px;
    background: #fafbfc;
    border-radius: 6px;
    
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #dcdfe6;
      border-radius: 4px;
    }
  }

  // 弹窗样式
  :deep(.el-dialog) {
    border-radius: 8px;
    
    .el-dialog__header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
      
      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
    
    .el-dialog__body {
      padding: 20px;
    }
    
    .el-dialog__footer {
      padding: 12px 20px;
      border-top: 1px solid #ebeef5;
    }
  }

  .agreement-footer {
    text-align: center;
    
    .el-button {
      border-radius: 6px;
      min-width: 100px;
    }
  }

  // 刷新按钮
  .el-button {
    border-radius: 6px;
  }
}
</style>
